import gql from 'graphql-tag'

export const usuariosByGruposUsuariosPagedQueryGql = gql`
  query UsuariosByGruposUsuariosPagedQuery(
    $filterInput: UsuariosByGruposUsuariosFilterInput
  ) {
    usuariosByGruposUsuariosPaged(filterInput: $filterInput) {
      content {
        id
        nome
        email
      }
      totalElements
    }
  }
`
